import Cookies from 'js-cookie';
import hcpEnrollmentFacilityService from "../services/hcpEnrollmentFacilityService";

const FACILITY_COOKIE_NAME = 'hcpfacilityid';
const FACILITY_NAME_COOKIE_NAME = 'hcpfacilityname';

const cookies = Cookies.withConverter({
    read: (value) => {
		if (!value) {
            return '';
        }
        return atob(value);
    },
    write: (value) => {
        return btoa(value);
    }
})

export default {
    state: () => ({
        facilities: [],
        myFacility: null,
        apiUrl: '/api/hcpfacility',
    }),
    getters: {
        getFacilities: (state) => state.facilities,
        getCurrentFacilityId: () => {
			const facilityName = cookies.get(FACILITY_COOKIE_NAME)
			if (facilityName) {
				return facilityName
			} else {
				return ''
			}
        },
        getCurrentFacility: (state) => {
            let id = cookies.get(FACILITY_COOKIE_NAME);
            if (id && state.facilities) {
                return state.facilities.find((facility) => facility.id === id);
            }
            return null;
        },
        getMyFacility: (state) => state.myFacility,
    },
    mutations: {
        setFacilities: (state, facilities) => {
            state.facilities = facilities;
        },
        setCurrentFacilityId: (state, facilityId) => {
			let domain = window.location.host;
            let m = /(\.?[^\.]+\.[^\.]+$)/.exec(domain);
			if (m) {
				domain = m[0];
				cookies.set(FACILITY_COOKIE_NAME, facilityId, { expires: 1 * 365 * 10, domain: domain });
				let facility = state.facilities.find((f) => f.id === facilityId);
				state.myFacility = facility;
				cookies.set(FACILITY_NAME_COOKIE_NAME, facility.name, { expires: 1 * 365 * 10, domain: domain });
			}
        },
        setMyFacility: (state, facility) => {
            state.myFacility = facility;
        },
    },
    actions: {
        fetchFacilities: ({ commit, state }) => {
            //commit('setSpinnerIsShown', true, { root: true })
            return hcpEnrollmentFacilityService.getAllFacilities(state.apiUrl)
                .then(response => {
                    commit('setFacilities', response.data);
                    //commit('setSpinnerIsShown', false, { root: true });
                })
                .catch(error => {
                    console.warn(error);
                    //commit('setSpinnerIsShown', false, { root: true });
                });
        },
        fetchMyFacility: ({ commit, state }) => {
            //commit('setSpinnerIsShown', true, { root: true });
			return hcpEnrollmentFacilityService.getMyFacility(state.apiUrl)
                .then(response => {
                    commit('setMyFacility', response.data);
                    //commit('setSpinnerIsShown', false, { root: true });
                })
                .catch(error => {
                    console.warn(error);
                    //commit('setSpinnerIsShown', false, { root: true });
                });
        }
    }
}
